import Vue from 'vue'
import draggable from 'vuedraggable'
import VueResource from 'vue-resource'
import VueSignaturePad from 'vue-signature-pad'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import vuetify from './plugins/vuetify'
import './plugins/vuetify-money.js'
import i18n from './i18n'
import { VueMaskDirective } from 'v-mask'
import css from './styles/variables.json'
import './styles/styles.scss'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { Calendar, DatePicker } from 'v-calendar'
import VCurrencyField from 'v-currency-field'
import { VTextField } from 'vuetify/lib'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'
import firebaseMessaging from './firebase'
import { installMigrationWatchers } from './config/v2'
import VEmojiPicker from 'v-emoji-picker'

Vue.use(VEmojiPicker)

Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'mdi',
})

Vue.component('DragDiv', draggable)

Vue.component('v-text-field', VTextField)
Vue.use(VCurrencyField, {
  locale: i18n.locale,
  decimalLength: 2,
  autoDecimalMode: true,
  min: null,
  max: null,
  defaultValue: 0,
  valueAsInteger: false,
  allowNegative: true,
})

Vue.use(VueSignaturePad)
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)
Vue.component('calendar', Calendar)
Vue.component('date-picker', DatePicker)

Vue.prototype.$customStyle = css
Vue.directive('mask', VueMaskDirective)
Vue.config.productionTip = false

Vue.$globalEvent = new Vue()

Vue.use(VueResource)

const options = {
  transition: 'Vue-Toastification__bounce',
  maxToasts: 3,
  newestOnTop: true,
  position: 'top-right',
  timeout: 5000,
  pauseOnFocusLoss: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  icon: true,
}
Vue.prototype.$messaging = firebaseMessaging

Vue.use(Toast, options)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  mounted() {
    installMigrationWatchers()

    Vue.$globalEvent.$on('httpError', (item) => {
      if (item.url.includes('listOpenCalled')) return
      if (item.body && item.body.message) {
        this.$toast.error(item.body.message.toString())
      } else if (item.body && item.body.content) {
        if (item.body.content.requireAuthenticate) {
          localStorage.removeItem('institution')
          localStorage.removeItem('token')
          localStorage.removeItem('expires')
          localStorage.removeItem('user')
          this.$router.push('/auth')
        }
        if (item.body.content && item.body.content.length > 0)
          this.$toast.error(item.body.content.toString())
      }
    })
  },
  render: (h) => h(App),
}).$mount('#app')
